<template>
  <div>
    <el-dialog
      title="新增黑名单项"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        size="mini"
      >
        <el-form-item label="类型：">
          <el-radio-group v-model="form.byType">
            <el-radio label="uid">UID</el-radio>
            <el-radio label="aid">AID</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="form.byType == 'uid' ? 'UID：' : 'AID：'"
          prop="byValue"
        >
          <el-input
            v-model="form.byValue"
            clearable
            style="width: 172px"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input
            v-model="form.remark"
            type="textarea"
            clearable
            style="width: 300px"
            rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      visible: true,
      form: {
        byType: "uid",
        byValue: "",
        remark: "", // 备注
      },
      rules: {
        byValue: [{ required: true, message: " ", trigger: "blur" }],
        remark: [{ required: true, message: " ", trigger: "blur" }],
      },
    };
  },

  props: {
    value: Object,
  },

  created() {
    if (this.value.radio == "uid") {
      this.form.byType = "uid";
      if (this.value.id) {
        this.form.byValue = this.value.id + "";
      }
    } else {
      this.form.byType = "aid";
      if (this.value.id) {
        this.form.byValue = this.value.id + "";
      }
    }
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      this.addBlackListEntry();
    },

    /**
     * 新增一个黑名单项
     */
    addBlackListEntry() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/addBlackListEntry`,
            {
              byType: this.form.byType,
              byValue: this.form.byValue,
              remark: this.form.remark,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>